module.exports = __webpack_public_path__ + "static/media/user-26.96f3d77c.png";